function playVideo(productCard) {
    let video = productCard.querySelector('.product-video');
    let image = productCard.querySelector('.media > img');
    
    if (video) {
      video.play();
      
      if (image) {
        image.style.opacity = "0"; // Oculta la imagen suavemente
      }
    }
  }
  
  function stopVideo(productCard) {
    let video = productCard.querySelector('.product-video');
    let image = productCard.querySelector('.media > img');
  
    if (video) {
      video.pause();
      video.currentTime = 0;
      
      if (image) {
        image.style.opacity = "1"; // Muestra la imagen de nuevo
      }
    }
}


/*
Want to customize your button? visit our documentation page:
https://login.equalweb.com/custom-button.taf
*/
window.interdeal = {
    get sitekey (){ return "6c9aa453ac5a6ab7b1f3dd1d5ab9d2cd"} ,
    get domains(){
        return {
            "js": "https://cdn.equalweb.com/",
            "acc": "https://access.equalweb.com/"
        }
    },
    "Position": "right",
    "Menulang": "EN",
    "draggable": true,
    "btnStyle": {
        "vPosition": [
            "90%",
            "75%"
        ],
        "margin": [
            "0",
            "0"
        ],
        "scale": [
            "0.4",
            "0.3"
        ],
        "color": {
            "main": "#000000",
            "second": "#ffffff"
        },
        "icon": {
            "outline": false,
            "outlineColor": "#ffffff",
            "type":  11 ,
            "shape": "circle"
        }
    },
                              
};

(function(doc, head, body){
    var coreCall             = doc.createElement('script');
    coreCall.src             = interdeal.domains.js + 'core/5.1.0/accessibility.js';
    coreCall.defer           = true;
    coreCall.integrity       = 'sha512-TcsprTlCCE0u/G5TN3zikzkynCEIRcfd96+RejMcyd2HFPnTpVUDxumXmFb/rSJ3ogQM+b/yvYWLwV6duAuJQg==';
    coreCall.crossOrigin     = 'anonymous';
    coreCall.setAttribute('data-cfasync', true );
    body? body.appendChild(coreCall) : head.appendChild(coreCall);
})(document, document.head, document.body);

document.addEventListener('click', function(e) {
  const size = e.target.closest('.card-size.active');
  if (!size) return;

  const variantId = size.dataset.variantId;
  if (!variantId) return;

  // 1️⃣ Add to cart
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(() => {
    // 2️⃣ Traer el HTML actualizado del drawer
    return fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(res => res.json());
  })
  .then(sections => {
    const formattedSections = {};
    for (const key in sections) {
      // En vez de extraer #CartDrawer, pasamos todo el HTML
      formattedSections[key] = sections[key];
    }

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) cartDrawer.renderContents({ sections: formattedSections });
  })
  .catch(err => console.error('Error al añadir al carrito:', err));
});
